<div>
  <div *ngIf="semEleicoes == true && permissaoGestor" class="row d-flex text-center align-items-center mt-3 mb-5">
    <div class="col-md-12">
      <h3 class="mt-4 mb-4"><strong>Olá, Gestor! </strong></h3>
      <h4>Ainda não existem eleições aqui. <br> Clique abaixo para começar a cadastrar!</h4>
      <button type="button" class="btn btn-success mt-5" (click)="cadastrarEleicao()" [disabled]="!permissaoGestor">CRIAR ELEIÇÃO</button>
    </div>
  </div>
  <div *ngIf="semEleicoes == false">
    <div class="row d-flex align-items-center">
      <div class="col-md-8">
        <h4 class="mt-4 mb-4" *ngIf="permissaoGestor"><strong>Olá, Gestor! </strong> <br> Aqui está sua lista de eleições <br></h4>
      </div>
      <div class="col-md-8">
        <h4 class="mt-4 mb-4" *ngIf="!permissaoGestor"><strong>Olá, Assistente! </strong> <br> Aqui está sua lista de eleições <br></h4>
      </div>
      <div class="d-flex justify-content-end col-md-4">
        <button type="button" class="btn btn-primary btn-eleicao" (click)="cadastrarEleicao()" [disabled]="!permissaoGestor">+ CRIAR ELEIÇÃO</button>
      </div>
    </div>
    <table class="table table-bordered">
      <thead>
        <th style="width: 20%;">TÍTULO</th>
        <th>SITUAÇÃO</th>
        <th>AUTENTICAÇÃO</th>
        <th>INICIADA</th>
        <th>FINALIZADA</th>
        <th>ZERÉSIMA</th>
        <th>AÇÕES</th>
        <th>CONFIG.</th>
        <th>EMAIL</th>
        <th>VER TELAS</th>
        <th>RELATÓRIOS</th>
      </thead>
      <tbody>
        <tr *ngFor="let eleicao of listaDeEleicoes ">
          <td>
            <b>{{eleicao.titulo}}</b>
          </td>
          <td> {{eleicao.statusEleicao.replace('_', ' ')}} </td>
          <td class="text-center">{{ (eleicao.acessoIntegracao != null && eleicao.acessoIntegracao == true) ? 'Integração' : 'Simples'}}</td>
          <td class="text-center">{{ eleicao.dataHoraInicio | date: 'dd/MM/yyyy HH:mm':'GMT-3' }}</td>
          <td class="text-center">{{ eleicao.dataHoraFim | date: 'dd/MM/yyyy HH:mm':'GMT-3' }}</td>
          <td class="text-center" >
            <button type="button" class="btn btn-light" (click)="buscarZeresima(eleicao.id)" pTooltip="visualizar" [disabled]="eleicao.statusEleicao == 'CRIADA'">
              <i class="fa fa-search"></i>
            </button>
          </td>
          <td class="text-center">
            <button type="button" *ngIf="eleicao.statusEleicao == 'APURADA'"
            class="btn btn-primary btn-eleicao" (click)="abrirResultado(eleicao.id, eleicao)" >
              RESULTADO
            </button>
            <button disabled type="button" *ngIf="eleicao.statusEleicao == 'CRIADA' && !eleicao.temCandidaturas || (eleicao.statusEleicao == 'EM_APROVACOES' && eleicao.candidatosGerados)"
            class="btn btn-success btn-eleicao" (click)="inserirZeresima(eleicao.id)" [disabled]="!permissaoGestor">
              ZERÉSIMA
            </button>
            <button type="button" *ngIf="eleicao.statusEleicao == 'ZERESIMA'"
            class="btn btn-success btn-eleicao" (click)="iniciarEleicao(eleicao.id,eleicao.dataHoraInicio)" [disabled]="!permissaoGestor">
              INICIAR
            </button>
            <button type="button" *ngIf="eleicao.eleicaoEncerrada && eleicao.statusEleicao == 'EM_ANDAMENTO'"
            class="btn btn-warning btn-eleicao" (click)="apurarEleicao(eleicao.id)" [disabled]="!permissaoGestor">
              APURAR
            </button>
            <button type="button" *ngIf="(eleicao.statusEleicao == 'EM_ANDAMENTO') && !eleicao.eleicaoEncerrada" class="btn btn-primary btn-eleicao" (click)="abrirResultadoParcial(eleicao.id, eleicao)">
              PARCIAL
            </button>
            <button type="button" *ngIf="eleicao.statusEleicao == 'CRIADA' && eleicao.temCandidaturas" class="btn btn-success btn-eleicao" (click)="iniciarCandidatura(eleicao.id, eleicao)"
             [disabled]="!permissaoGestor">
              INICIAR CANDIDATURAS
            </button>
            <button type="button" *ngIf="eleicao.statusEleicao == 'EM_CANDIDATURAS' && eleicao.temCandidaturas" class="btn btn-warning btn-eleicao" (click)="finalizarCandidatura(eleicao.id, eleicao)"
             [disabled]="!permissaoGestor">
              FINALIZAR CANDIDATURAS
            </button>
            <button type="button" *ngIf="eleicao.statusEleicao == 'AGUARDANDO_APROVACOES' && eleicao.temCandidaturas" class="btn btn-warning btn-eleicao" (click)=" iniciarAprovacoes(eleicao.id, eleicao)"
             [disabled]="!permissaoGestor">
              INICIAR APROVAÇÕES
            </button>
            <button disabled type="button" *ngIf="eleicao.statusEleicao == 'EM_APROVACOES' && !eleicao.candidatosGerados"
            class="btn btn-success btn-eleicao" (click)="gerarCandidatos(eleicao.id)" [disabled]="!permissaoGestor">
              GERAR CANDIDATOS
            </button>
          </td>
          <td class="text-center">
            <button class="btn btn-light" (click)="parametrizacoesEleicao(eleicao)"  [disabled]="!permissaoGestor">
              <i class="fas fa-cogs"></i>
            </button>
          </td>
          <td class="text-center">
            <button type="button" class="btn btn-light" (click)="parametrizacoesEmail(eleicao)" pTooltip="Config. Envio" [disabled]="!eleicao.enviaEmails">
              <i class="fas fa-envelope"></i>
            </button>
          </td>
          <td class="text-center">
            <button type="button" class="btn btn-light" (click)="abrirVisualizacaoEleicao(eleicao)" pTooltip="Pré-visualizar">
              <i class="far fa-eye"></i>
            </button>
          </td>
          <td class="text-center">
            <div style="display: flex;">
            <button style="margin-inline: 6px;" type="button" class="btn btn-light" (click)="abrirRelatorioVotos(eleicao.id, eleicao)" pTooltip="Relatório de votos">
              <i style="color: rgb(25, 25, 226);" class="fas fa-file-alt"></i>
            </button>
            <button style="margin-inline: 6px;" type="button" class="btn btn-light" (click)="buscarLogsAcesso(eleicao.id,eleicao)" pTooltip="Relatório de Logins">
              <i style="color: #F03A2B;" class="fas fa-file-download"></i>
            </button>
            <button style="margin-inline: 6px;" type="button" class="btn btn-light" (click)="abrirRelatorioEmails(eleicao.id,eleicao)" pTooltip="Relatório de Envio de Email">
              <i style="color:darkgoldenrod;" class="fas fa-envelope"></i>
            </button>
            <button style="margin-inline: 6px;" type="button" class="btn btn-light" (click)="abrirModalRelatoriosCandidaturas(eleicao.id)" pTooltip="Relatório de Candidaturas">
              <i style="color: green;" class="fas fa-file-download"></i>
            </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="modal fade" id="modalConfirmarApuracao" tabindex="-1" aria-labelledby="modalApuracaoLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title text-center" id="modalApuracaoLabel">Atenção!</h2>
        <button type="button" class="btn-close" (click)="cancelarApuracao()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h4>Deseja realmente realizar a apuração desta eleição? Esta ação não poderá ser desfeita.</h4>
      </div>
      <div class="modal-footer text-center">
        <button type="button" class="btn btn-secondary" (click)="confirmarApuracao()">Sim</button>
        <button type="button" class="btn btn-secondary" (click)="cancelarApuracao()">Não</button>
      </div>
    </div>
  </div>
</div>